import { atom } from 'recoil'
import { FilterStateTypes } from './types'

export const filters = atom({
  key: 'filters',
  default: {} as FilterStateTypes
})
